import React from 'react';
import ProtectedRoute from './ProtectedRoutes';

/**
 * Role-specific route wrappers
 * Use these as the `element` on route definitions to gate entire route trees.
 *
 * Each one delegates to ProtectedRoute — add permissions array to make
 * the check stricter (requireAll = false by default → ANY match passes).
 */

/** Roads / Civils route tree */
export const RoadsProtectedRoute = ({ children }) => (
    <ProtectedRoute roles={['roads', 'super_admin', 'system_admin', 'department_head', 'civils_officer']} permissions={['roads.read']}>
        {children}
    </ProtectedRoute>
);

/** Accounting route tree */
export const AccountingProtectedRoute = ({ children }) => (
    <ProtectedRoute
        roles={['accounting_officer', 'super_admin', 'system_admin', 'department_head']}
        permissions={['financial_records.read', 'certificates.review_accounting', 'certificates.approve_accounting']}
    >
        {children}
    </ProtectedRoute>
);

/** Procurement route tree */
export const ProcurementProtectedRoute = ({ children }) => (
    <ProtectedRoute
        roles={['procurement_officer', 'super_admin', 'system_admin', 'department_head']}
        permissions={['certificates.review_procurement', 'certificates.approve_procurement', 'suppliers.read', 'contractors.read']}
    >
        {children}
    </ProtectedRoute>
);

/** Quantity Surveyor route tree */
export const QsProtectedRoute = ({ children }) => (
    <ProtectedRoute
        roles={['quantity_surveyor', 'super_admin', 'system_admin', 'department_head']}
        permissions={[
            'certificates.review_qs',
            'certificates.approve_qs',
            'certificates.create',
            'certificates.update',
            'certificates.read'
        ]}
    >
        {children}
    </ProtectedRoute>
);

/** Quantity Surveyor route tree */
export const ArchitectureProtectedRoute = ({ children }) => (
    <ProtectedRoute
        roles={['architect', 'architecture_officer', 'super_admin', 'system_admin', 'department_head']}
        permissions={[
            'projects.create',
            'project_stages.create',
            'projects.read',
            'project_stages.read',
            'project_stages.update',
            'projects.update',
            'reports.read'
        ]}
    >
        {children}
    </ProtectedRoute>
);

/** Project Manager / Department Head route tree */
export const ProjectsProtectedRoute = ({ children }) => (
    <ProtectedRoute roles={['project_manager', 'department_head', 'super_admin', 'system_admin']} permissions={['projects.read']}>
        {children}
    </ProtectedRoute>
);

/** Reports route tree */
export const ReportsProtectedRoute = ({ children }) => <ProtectedRoute permissions={['reports.read']}>{children}</ProtectedRoute>;

/** Audit logs — admin + accounting only */
export const AuditProtectedRoute = ({ children }) => (
    <ProtectedRoute roles={['super_admin', 'system_admin', 'accounting_officer']} permissions={['audit_logs.read']}>
        {children}
    </ProtectedRoute>
);
